var crRecaptcha = (function() {
	return {
		init: function() {
			this.recaptchaLoadKey        = window.recaptchaLoadKey;

			this.recaptchaV2SiteKey      = window.recaptchaV2SiteKey;
			this.recaptchaV2Enabled      = window.recaptchaV2Enabled;
			this.recaptchaV2AlwaysVerify = window.recaptchaV2AlwaysVerify;

			this.recaptchaV3SiteKey      = null;
			this.recaptchaV3Enabled      = false; //affects only collecting the data on pageload
			this.recaptchaV3ContactsEnabled = false; //affects contact forms
			this.recaptchaV3SubmitUrl    = null;

			this.recaptchaV2Token        = null;
			this.recaptchaV3Token        = null;

			this.widgetId                = null;
			this.callback                = null;
			this.isRecaptchaLibLoaded    = false;
			this.isRenderRunning         = false;
			this.wasSuccessfullyVerified = false;
			this.isDebug                 = false;

			this.debug("CrRecaptcha:init, loadKey = " + this.recaptchaLoadKey);

			this.debug("CrRecaptcha:init, V2 enabled = " + this.recaptchaV2Enabled);
			this.debug("CrRecaptcha:init, V2 always verify = " + this.recaptchaV2AlwaysVerify);
			this.debug("CrRecaptcha:init, V3 enabled = " + this.recaptchaV3Enabled);
			this.debug("CrRecaptcha:init, V3 contacts enabled = " + this.recaptchaV3ContactsEnabled);

			if (this.recaptchaV3Enabled) {
				this.executeV3OnPageload();
			}
		},

		setSuccessState: function(state) {
			this.debug("CrRecaptcha:setSuccessState state = " + state);
			this.wasSuccessfullyVerified = state;

			if (!state) {
				this.refresh();
			}
		},

		refresh: function() {
			if (this.widgetId !== null && typeof grecaptcha !== "undefined" && grecaptcha.reset) {
				this.debug("CrRecaptcha:refresh resetting recaptcha");
				grecaptcha.reset(this.widgetId);
			}
		},

		render: function() {
			this.debug("CrRecaptcha:render");
			this.debug("CrRecaptcha:render recaptchaV2Token:" + this.recaptchaV2Token);
			if (this.recaptchaV2Enabled && this.recaptchaV2Token === null) {
				var self = this;
				var intervalId = null;
				var attempts = 25;

				this.isRenderRunning = true;

				var tryRenderCaptcha = function() {
					self.debug("CrRecaptcha:render:tryRenderCaptcha(" + attempts + ")");

					if (typeof grecaptcha !== "undefined" && grecaptcha.render && self.widgetId === null) {
						self.widgetId = grecaptcha.render("cr-recaptcha", {
							"sitekey": self.recaptchaV2SiteKey,
							"callback": function(response) {
								self.recaptchaCallback(response);
							},
							"size": "invisible"
						});

						self.debug("CrRecaptcha:render rendered. widgetId = " + self.widgetId);

						clearInterval(intervalId);
						self.isRenderRunning = false;
					}

					if (attempts-- <= 0 || self.widgetId !== null) {
						clearInterval(intervalId);
						self.isRenderRunning = false;
					}
				};

				tryRenderCaptcha();

				if (this.widgetId === null) {
					intervalId = setInterval(tryRenderCaptcha, 200);
				}
			}
		},

		execute: function(callback, action, execV2) {
			this.debug("CrRecaptcha:execute");

			if (typeof action === "undefined") {
				action = "generic_post";
			}

			if (typeof execV2 === "undefined") {
				execV2 = true;
			}

			this.callback = callback;

			var self = this;

			this.loadRecaptchaLib();
			this.executeV3(action, "POST", function() { self.executeV2(execV2); });
		},

		loadRecaptchaLib: function() {
			this.debug("CrRecaptcha:loadRecaptchaLib");
			if (!this.isRecaptchaLibLoaded && this.recaptchaLoadKey) {
				var self = this;
				self.debug("CrRecaptcha:loadRecaptchaLib loading");
				let script = document.createElement("script");
				script.onload = function() {
					self.isRecaptchaLibLoaded = true;
					self.debug("CrRecaptcha:loadRecaptchaLib loaded");
				};
				script.src = "https://www.google.com/recaptcha/api.js?render=" + self.recaptchaLoadKey;
				document.head.appendChild(script);
			}
		},

		executeV2: function(execV2) {
			this.debug("CrRecaptcha:executeV2");

			if (this.recaptchaV2Enabled && execV2 && (!this.wasSuccessfullyVerified || this.recaptchaV2AlwaysVerify)) {
				if (this.widgetId === null) {
					this.render();
				}

				if (this.recaptchaV2Token === null) {
					var self = this;
					var attempts = 30;
					var tryExecuteCaptcha = function () {
						self.debug("CrRecaptcha:executeV2:tryExecuteCaptcha(" + attempts + ")");
						self.debug("CrRecaptcha:executeV2:tryExecuteCaptcha isRenderRunning = " + self.isRenderRunning);

						if (!self.isRenderRunning && self.widgetId !== null) {
							self.debug("CrRecaptcha:executeV2:tryExecuteCaptcha:execute(" + attempts + ")");
							try {
								grecaptcha.execute(self.widgetId);
							} catch (e){
								self.debug(e);
							}
						} else {
							if (self.widgetId === null && attempts <= 0) {
								self.debug("CrRecaptcha:executeV2 render failed(" + attempts + ")");
								self.debug("CrRecaptcha:executeV2 calling callback to unlock the form (even though the BED request will fail)")
								self.callback(null);
							} else {
								self.debug("CrRecaptcha:executeV2 render is still running(" + attempts + ")");
								if (attempts > 0) {
									setTimeout(tryExecuteCaptcha, 200);
								}
							}
						}
						attempts--;
					};

					tryExecuteCaptcha();
				}
			} else {
				if (typeof this.callback === "function") {
					this.debug("CrRecaptcha:executeV2 calling callback directly")
					this.callback(null);
				}
			}
		},

		recaptchaCallback: function(response) {
			this.debug("CrRecaptcha:callback token received")
			if (response) {
				this.recaptchaV2Token = response;

				if (typeof this.callback === "function") {
					this.debug("CrRecaptcha:callback calling callback")
					this.callback(this.recaptchaV2Token);
					this.recaptchaV2Token = null;
					this.refresh();
				}
			}
		},

		executeV3OnPageload: function() {
			var self = this;
			var attempts = 50;

			var scheduleV3Execution = function() {
				if (typeof grecaptcha !== "undefined" && grecaptcha.ready) {
					self.debug("CrRecaptcha:executeV3OnPageload::scheduleV3Execution scheduling (" + attempts + ")");

					grecaptcha.ready(() => {
						self.executeV3("page_load", "GET");
					});
				} else {
					self.debug("CrRecaptcha:executeV3OnPageload::scheduleV3Execution is still not ready (" + attempts + ")");
					if (attempts > 0) {
						setTimeout(scheduleV3Execution, 200);
					}
				}
				attempts--;
			};

			scheduleV3Execution();
		},

		executeV3: function(action, method, callback) {
			this.debug("CrRecaptcha:executeV3. Action = " + action + "; method = " + method);
			if (this.recaptchaV3ContactsEnabled) {
				var self = this;
				try {
					grecaptcha.execute(self.recaptchaV3SiteKey, {action: action}).then((token) => {
						self.recaptchaV3Callback(token, method, callback);
					});
				} catch (e){
					self.debug(e);
				}
			} else {
				this.debug("Recaptcha V3 disabled");
				this.recaptchaV3Callback(null, method, callback);
			}
		},

		recaptchaV3Callback: function(token, method, callback) {
			this.debug("CrRecaptcha:recaptchaV3Callback");

			if (method == "GET" && this.recaptchaV3SubmitUrl && token) {
				var csrfToken = document.querySelector("meta[name=csrf-token]").content;
				var xhttp = new XMLHttpRequest();
				xhttp.open("POST", this.recaptchaV3SubmitUrl, true);
				xhttp.setRequestHeader("Content-type", "application/json");
				xhttp.setRequestHeader("X-CSRF-Token", csrfToken);
				xhttp.withCredentials = true;
				xhttp.send(JSON.stringify({
					token: token,
					pathname: window.location.pathname,
					bodyId: document.querySelector("body").id
				}));
				xhttp.onreadystatechange = function() {
					if (this.readyState === 4 && this.status === 200) {/* success*/ }
				};
			} else {
				this.debug("CrRecaptcha:recaptchaV3Callback setting V3 token");
				this.recaptchaV3Token = token;

				if (typeof callback === "function") {
					this.debug("CrRecaptcha:recaptchaV3Callback calling callback")
					callback(null);
				}
			}
		},

		getTokens: function() {
			return {
				v2: this.recaptchaV2Token,
				v3: this.recaptchaV3Token,
				pathname: window.location.pathname,
				bodyId: document.querySelector("body").id
			};
		},

		getTokensStr: function(param) {
			var reCaptchaTokens = this.getTokens();
			return Object.keys(reCaptchaTokens).map(key => param + "[" + key + "]" + "=" + reCaptchaTokens[key]).join("&");
		},

		debug: function(msg) {
			if (this.isDebug) {
				console.log(msg)
			}
		}
	}
})();
